/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ nights: NonNullable<unknown> }} Picker_Min_NightsInputs */

const en_picker_min_nights = /** @type {(inputs: Picker_Min_NightsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Minimum ${i?.nights} nights from this date`)
};

/**
* | output |
* | --- |
* | "Minimum {nights} nights from this date" |
*
* @param {Picker_Min_NightsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const picker_min_nights = /** @type {((inputs: Picker_Min_NightsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Picker_Min_NightsInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_picker_min_nights(inputs)
});